import { AccordionDetails, Stack } from '@mui/material';
import Link from 'next/link';
import { FC } from 'react';

import { AbgTypography, formatMoney } from '@abg/kit-base';
import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { useTranslationContext } from '../../../../shared/context';
import { getTaxLabel } from '../../../../shared/utils/get-tax-label';
import { bookingFlowStoreSelector } from '../../../../store';
import { CostListType } from '../../car-info-accordion.types';
import { checkoutMobileAccordionDetailsStyling } from '../../CarInfoAccordion.styling';

import { CarInfoTaxesProps } from './car-info-taxes.types';
import {
  accordionDetails,
  linkStyles,
  priceStyles,
  textStyles,
  wrapperStyles,
} from './CarInfoTaxes.styling';

// This component designed specifically for taxes since it has mapping with links
// do not use it for other purposes.
export const CarInfoTaxes: FC<CarInfoTaxesProps> = ({
  costList,
  currency = 'USD',
  isCheckoutMobile,
}) => {
  const { navigationLinks, region } = usePageContext() || {};
  const { t } = useTranslationContext();
  const pickupCountryCode = bookingFlowStoreSelector.use.pickupCountryCode?.();
  const isApac = region === 'apac';

  const makeLink = (cost: CostListType) => {
    if (isApac) return;

    if (!navigationLinks?.taxFee) {
      return;
    }

    if (!cost?.code) {
      return navigationLinks?.taxFee;
    }

    return `${navigationLinks?.taxFee}#${cost?.code}`;
  };

  if (!costList?.length) {
    return null;
  }

  return (
    <AccordionDetails
      sx={
        isCheckoutMobile
          ? checkoutMobileAccordionDetailsStyling
          : accordionDetails
      }
    >
      <Stack
        direction="column"
        sx={{ marginTop: isCheckoutMobile ? '6px' : 0 }}
        rowGap={isCheckoutMobile ? '6px' : 1}
      >
        {costList.map((cost, key) => {
          const link = makeLink(cost);
          const isLink = !!link;

          return (
            <Stack
              sx={wrapperStyles}
              key={key}
              direction="row"
              justifyContent="space-between"
            >
              <AbgTypography
                {...(isLink && {
                  href: link,
                  target: '_blank',
                  prefetch: false,
                })}
                component={isLink ? Link : 'div'}
                sx={isLink ? linkStyles : textStyles}
                variant="bodySmallRegular"
              >
                {cost.code?.toUpperCase() === 'TAX'
                  ? getTaxLabel(t, pickupCountryCode)
                  : cost.description && cost.description.length > 0
                    ? cost.description
                    : t(`reservationCheckout.taxAndFees.${cost.code}.label`)
                          .length > 0
                      ? t(`reservationCheckout.taxAndFees.${cost.code}.label`)
                      : ''}
              </AbgTypography>

              <AbgTypography sx={priceStyles} variant={'bodySmallRegular'}>
                {formatMoney(cost.amount, { currency })}
              </AbgTypography>
            </Stack>
          );
        })}
      </Stack>
    </AccordionDetails>
  );
};
